import React, { useRef, useState, useEffect } from 'react';
import './OpalSearchInput.css';
import TauriImage from '../TauriImage/TauriImage';

const OpalSearchInput = ({
    selectedItem,
    onSelectedItem,
    items = [],
    placeholder = 'Search...',
    onMouseEnter,
    onMouseLeave,
    onMouseOver,
    onMouseOut,
    onMouseDown,
    onMouseUp,
    onMouseMove
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const [inputText, setInputText] = useState(selectedItem?.Name || '');
    const wrapperRef = useRef(null);

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setShowMenu(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        setInputText(selectedItem?.Name || '');
    }, [selectedItem]);

    const filteredItems = items.filter(item =>
        item.Name.toLowerCase().includes(inputText.toLowerCase())
    );

    return (
        <div className="opal-search-input-wrapper" ref={wrapperRef}>
            <div className="opal-search-input-container">
                <input
                    type="text"
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    onFocus={() => setShowMenu(true)}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    onMouseDown={onMouseDown}
                    onMouseUp={onMouseUp}
                    onMouseMove={onMouseMove}
                    placeholder={placeholder}
                    className="opal-search-input"
                />
            </div>

            {showMenu && filteredItems.length > 0 && (
                <div className="opal-search-dropdown">
                    {filteredItems.map((item) => (
                        <div
                            key={item.ID}
                            className="opal-search-dropdown-item"
                            onClick={() => {
                                onSelectedItem(item);
                                setInputText(item.Name);
                                setShowMenu(false);
                            }}
                        >
                            {item.Name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default OpalSearchInput;
